import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { useUpgradeBannerSubmit } from "../../hooks/useUpgradeBannerSubmit";
import SuccessBanner from "../SuccessBanner/SuccessBanner";

import { StyledUpgradeBannerWrapper, StyledBannerTrial } from "./styles";
import type { IFeatureUpgradeBannerProps } from "./types";

interface IProps extends IFeatureUpgradeBannerProps {
    titleKey: string;
}

const FeatureUpgradeBanner = ({
    titleKey,
    subtitleKey,
    buttonTextKey,
    headerKey,
    isSubmitted = false,
    withSuccessView = true,
    onSubmit,
}: IProps) => {
    const { translate } = useTranslate();

    const { isSuccessViewVisible, onButtonClick } = useUpgradeBannerSubmit({
        isSubmitted,
        withSuccessView,
        onSubmit,
    });

    if (isSuccessViewVisible) {
        return (
            <SuccessBanner
                title={translate("hook_modal.get_feature.success.title")}
                subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
            />
        );
    }
    return (
        <StyledUpgradeBannerWrapper>
            {headerKey ? <Text fontVariant="subtitle1">{translate(headerKey)}</Text> : null}

            <StyledBannerTrial
                title={translate(titleKey)}
                subtitle={translate(subtitleKey)}
                buttonType="trial"
                buttonText={translate(buttonTextKey)}
                buttonIconName="sparkles"
                bannerBackground={colorsPalettes.sky["100"]}
                onButtonClick={onButtonClick}
            />
        </StyledUpgradeBannerWrapper>
    );
};

export default FeatureUpgradeBanner;
